// Despachador do módulo Admin — cada entrada da sidebar
// (admin-usuarios, admin-perfis, admin-permissoes, admin-d4sign,
// admin-empresa, admin-backlog, admin-aws-costs) renderiza
// <Admin initialTab="..." />, que despacha pro subcomponente
// apropriado em ./admin/.
import { App as AntApp } from 'antd';
import AdminPerfis from './AdminPerfis';
import AdminPermissoes from './admin/AdminPermissoes';
import AdminBacklog from './admin/AdminBacklog';
import AdminUsuarios from './admin/AdminUsuarios';
import AdminEmpresa from './admin/AdminEmpresa';
import AdminAwsCustos from './admin/AdminAwsCustos';
import AdminBackupCrescimento from './admin/AdminBackupCrescimento';
import AdminD4SignImpl from './admin/AdminD4Sign';
import type { AdminTab } from './admin/types';

// Reexport AdminD4Sign pra preservar import existente em AdminIntegracoes.tsx.
export const AdminD4Sign = AdminD4SignImpl;

export default function Admin({ initialTab = 'usuarios' }: { initialTab?: AdminTab } = {}) {
  const sub = (() => {
    switch (initialTab) {
      case 'usuarios':   return <AdminUsuarios />;
      case 'perfis':     return <AdminPerfis />;
      case 'permissoes': return <AdminPermissoes />;
      case 'd4sign':     return <AdminD4SignImpl />;
      case 'empresa':    return <AdminEmpresa />;
      case 'backlog':    return <AdminBacklog />;
      case 'aws-costs':  return <AdminAwsCustos />;
      case 'backup-nas': return <AdminBackupCrescimento />;
      default:           return <AdminUsuarios />;
    }
  })();
  return (
    <AntApp>
      <div style={{ maxWidth: 1300, margin: '16px auto', padding: '0 24px' }}>
        {sub}
      </div>
    </AntApp>
  );
}
